import { useState, useEffect, useRef } from 'react';

const useMobileNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleRef = useRef(null);
  const menuRef = useRef(null);

  const openMenu = () => {
    setIsOpen(true);
    if (toggleRef.current) {
      toggleRef.current.setAttribute('aria-expanded', 'true');
    }
    if (menuRef.current) {
      menuRef.current.setAttribute('aria-expanded', 'true');
      // Focus first menu item
      const firstLink = menuRef.current.querySelector('a');
      if (firstLink) {
        firstLink.focus();
      }
    }
  };

  const closeMenu = () => {
    setIsOpen(false);
    if (toggleRef.current) {
      toggleRef.current.setAttribute('aria-expanded', 'false');
    }
    if (menuRef.current) {
      menuRef.current.setAttribute('aria-expanded', 'false');
    }
  };

  const toggleMenu = () => {
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isOpen &&
        toggleRef.current &&
        menuRef.current &&
        !toggleRef.current.contains(e.target) &&
        !menuRef.current.contains(e.target)
      ) {
        closeMenu();
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        closeMenu();
        if (toggleRef.current) {
          toggleRef.current.focus();
        }
      }
    };

    const handleResize = () => {
      if (window.innerWidth > 768 && isOpen) {
        closeMenu();
      }
    };

    // Close menu when clicking nav links
    const handleNavLinkClick = () => {
      if (isOpen) {
        closeMenu();
      }
    };

    if (menuRef.current) {
      const navLinks = menuRef.current.querySelectorAll('a');
      navLinks.forEach((link) => {
        link.addEventListener('click', handleNavLinkClick);
      });
    }

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    window.addEventListener('resize', handleResize);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      window.removeEventListener('resize', handleResize);
      if (menuRef.current) {
        const navLinks = menuRef.current.querySelectorAll('a');
        navLinks.forEach((link) => {
          link.removeEventListener('click', handleNavLinkClick);
        });
      }
    };
  }, [isOpen]);

  return {
    isOpen,
    toggleMenu,
    toggleRef,
    menuRef,
  };
};

export default useMobileNav;

